/** Shared exact protocol messages; server authorization still requires a review grant. */
export function generatedImageReviewMessage(
  side: "front" | "back",
  isModification: boolean
): string {
  if (isModification) {
    return `Review the attached modified ${side} design image against the customer's latest requested edit. Describe only visible evidence, acknowledge any mismatch or uncertainty, and do not assume the edit succeeded. Ask what the user would like to do next.`;
  }
  return side === "front"
    ? "Review the attached front design image. Briefly describe what you see (color, silhouette, neckline, sleeves, length) and ask if the user wants changes or wants to move to back design."
    : "Review the attached back design image. Briefly describe what you see and ask if the user wants changes or is ready to submit the complete design.";
}

// Include legacy messages for already-open clients. An exact match alone
// never authorizes a review: the server must also consume its one-time grant.
export const GENERATED_IMAGE_REVIEW_MESSAGES = new Map<
  string,
  { side: "front" | "back"; isModification: boolean }
>([
  [
    "Review the attached front design image. Briefly describe what you see (color, silhouette, neckline, sleeves, length) and ask if the user wants changes or wants to move to back design.",
    { side: "front", isModification: false },
  ],
  [
    "Review the attached modified front design image. Explicitly confirm what changed (e.g. 'Updated: Added short sleeves. Here's the new design.') and ask if the user wants more modifications or wants to move to back design.",
    { side: "front", isModification: true },
  ],
  [
    "Review the attached back design image. Briefly describe what you see and ask if the user wants changes or is ready to submit the complete design.",
    { side: "back", isModification: false },
  ],
  [
    "Review the attached modified back design image. Explicitly confirm what changed (e.g. 'Updated: Lowered the back. Here's the new design.') and ask if the user wants more modifications or is ready to submit the complete design.",
    { side: "back", isModification: true },
  ],
]);

for (const side of ["front", "back"] as const) {
  GENERATED_IMAGE_REVIEW_MESSAGES.set(generatedImageReviewMessage(side, true), {
    side,
    isModification: true,
  });
}
